import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";

const CustomHospitalizationProtocols = () => {
  return (
    <Grid container sx={design.Container}>
      <Grid size={design.grid15} />
      <Grid size={design.grid9}>
        <CustomText
          color="#D87FF4"
          fontWeight={500}
          fontFamily="Nunito"
          textAlign="left"
          width="100%"
          sx={design.TextPrinc}
        >
          NUESTROS SERVICIOS
        </CustomText>
        <CustomText
          color="#FFFFFF"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="left"
          width="100%"
          sx={design.TextProyect}
        >
          Preparados para cada segundo crítico
        </CustomText>
        <CustomText
          color="#DCDDDE"
          fontWeight={500}
          fontFamily="Nunito"
          textAlign="left"
          width="100%"
          sx={design.TextDescription}
        >
          Protocolos activos las 24 horas para responder con velocidad y
          precisión cuando más se necesita.
        </CustomText>
      </Grid>
      <Grid size={design.grid15} />
      <Grid size={design.grid15} />
      <Grid container size={design.grid12} sx={design.CardsContainer}>
        {data.map((doc, index) => (
          <Grid size={design.grid18} key={index}>
            <Box sx={design.Card}>
              <Box sx={design.Status(doc)}>
                <Box sx={design.StatusDot} />
                <CustomText
                  fontFamily="Nunito"
                  fontWeight={700}
                  color="#FFFFFF"
                  sx={design.StatusText}
                >
                  ACTIVO
                </CustomText>
              </Box>
              {/* TÍTULO */}
              <CustomText
                fontFamily="Nunito"
                fontWeight={700}
                color="#FFFFFF"
                sx={design.CardTitle}
              >
                {doc.titulo}
              </CustomText>
              {/* DESCRIPCIÓN */}
              <CustomText
                fontFamily="Nunito"
                fontWeight={400}
                color="#FFFFFF"
                textAlign="left"
                sx={design.CardDescription}
              >
                {doc.description}
              </CustomText>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid size={design.grid15} />
    </Grid>
  );
};

export default CustomHospitalizationProtocols;

const design = {
  Container: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    backgroundColor: "#101E4B",
    boxSizing: "border-box",
    py: { xs: 4, sm: 5, md: 5, lg: 4.5 },
  },
  grid15: { xs: 0.5, sm: 1.5, md: 1.5, lg: 1.5 },
  grid9: { xs: 11, sm: 9, md: 9, lg: 9 },
  grid12: { xs: 11, sm: 12, md: 12, lg: 12 },
  grid18: { xs:5.5, sm: 1.8, md: 1.8, lg: 1.8 },
  TextPrinc: {
    fontSize: { xs: 16, sm: 15, md: 16, lg: 15 },
    lineHeight: 1.2,
    letterSpacing: "0.2px",
    mt: { xs: 0, md: 0 },
    mb: { xs: 1.5, md: 2 },
  },
  TextProyect: {
    fontSize: { xs: 32, sm: 38, md: 46, lg: 48 },
    lineHeight: 1.1,
    letterSpacing: "-0.5px",
    mb: { xs: 1.5, md: 2 },
  },
  TextDescription: {
    fontSize: { xs: 16, sm: 16, md: 17, lg: 17 },
    lineHeight: 1.4,
  },
  CardsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mx: "auto",
    mt: { xs: 1, sm: 5, md: 3 },
    mb: { xs: 1, md: 1 },
    gap: { xs: 1.8, sm: 2.5, md: 2.5, lg: 2.2 },
  },
  Card: {
    width: "100%",
    height: { xs: 180, sm: 190, md: 175, lg: 160 },
    boxSizing: "border-box",
    backgroundColor: "rgba(255, 255, 255, 0.16)",
    border: "1px solid rgba(255, 255, 255, 0.45)",
    borderRadius: "18px",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    padding: { xs: 2, sm: 2, md: 2, lg: 2 },
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    transition: "transform 0.25s ease, background-color 0.25s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      backgroundColor: "rgba(255, 255, 255, 0.19)",
    },
  },
  Status: (doc) => ({
    height: "25px",
    minWidth: "88px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    px: 1.2,
    boxSizing: "border-box",
    mb: { xs: 2.5, md: 2.2 },
    backgroundColor: doc.color,
  }),
  StatusDot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.85)",
  },
  StatusText: {
    fontSize: { xs: 10, md: 10 },
    lineHeight: 1,
  },
  CardTitle: {
    fontSize: { xs: 17, sm: 18, md: 17, lg: 17 },
    lineHeight: 1.2,
    mb: 1,
    whiteSpace: "nowrap",
  },
  CardDescription: {
    fontSize: { xs: 13, sm: 14, md: 13, lg: 13 },
    lineHeight: 1.25,
    opacity: 0.95,
  },
};

const data = [
  {
    color: "#D93434",
    titulo: "Código Infarto",
    description: "Atención cardiaca urgente",
  },
  {
    color: "#E76ED3",
    titulo: "Código Mater",
    description: "Emergencia obstétrica",
  },
  {
    color: "#F28A00",
    titulo: "Código Stroke",
    description: "Respuesta a evento cerebrovascular",
  },
  {
    color: "#F4C542",
    titulo: "Código Trauma",
    description: "Manejo de lesiones graves",
  },
  {
    color: "#3A79C7",
    titulo: "Código Urgencias",
    description: "Maniobras de reanimación cardiopulmonar (RCP)",
  },
];
